export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100">
              <i className="ri-film-line text-2xl text-primary-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              关于午马
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              午马影院是面向全球华语观众的免费电影在线观看平台，自上线以来持续收录海内外最新电影资源，覆盖动作大片、科幻巨制、温情喜剧、烧脑悬疑与高分动画等多元类型。我们坚持每日同步更新，依托智能秒播技术与高清片源库，为影迷提供零缓冲、高画质的流畅观影体验。无论是经典老片回顾还是新片抢先看，午马影院始终以最丰富的电影大全和最稳定的播放质量，成为您观影生活的最佳伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}